function getIncompleteTaskIdsOnServer () {
  if (!this.tasks) return
  return Object.values(this.tasks).filter(task => task.serverId && !task.complete).map(({ id }) => id)
}

export default getIncompleteTaskIdsOnServer